import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { AuthContext } from "./Auth";
import { signOut } from "firebase/auth";
import { auth } from "./firebase";
import "bootstrap/dist/css/bootstrap.min.css";
import foxlogo from "./foxlogo.png";
import Tooltip from "./Layouts/Tooltip";

const Navbar = () => {
  const { user } = useContext(AuthContext);

  const handleLogout = async () => {
    console.log("Logging out...");
    try {
      await signOut(auth);
      console.log("Logged out successfully");
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <header>
      <nav className="navbar">
        <img src={foxlogo} alt="BadBank Fox Logo" className="foxlogo" />
        <h1>FoxBank</h1>
        <Tooltip text="Home">
          <NavLink to="/" exact>
            Home
          </NavLink>
        </Tooltip>
        <Tooltip text="Create Account">
          <NavLink to="/CreateAccount">Create Account</NavLink>
        </Tooltip>
        <Tooltip text="Login">
          <NavLink to="/Login">Login</NavLink>
        </Tooltip>
        <Tooltip text="Deposit">
          <NavLink to="/Deposit">Deposit</NavLink>
        </Tooltip>
        <Tooltip text="Withdraw">
          <NavLink to="/Withdraw">Withdraw</NavLink>
        </Tooltip>
        {/* <Tooltip text="All Data">
          <NavLink to="/AllData">Admin Panel</NavLink>
        </Tooltip> */}
        <Tooltip text="Help">
          <NavLink to="/Help">Help</NavLink>
        </Tooltip>
        {user ? (
          <div className="user-info">
            <span>Welcome, {user.email}</span>
            <button onClick={handleLogout}>Logout</button>
          </div>
        ) : null}
      </nav>
    </header>
  );
};

export default Navbar;
